<template>
    <div>
        <app-form
            v-bind:parentObject="{
            data: this.formData,
            pageTitle: this.pageTitle,
            errMsg: this.errMsg,
            isEdit: this.editMode,
            }"
            v-on:input="formData = $event"
            v-on:save="saveHandler"
            v-on:error="errorHandler"
        />
        <div v-if="isErr">
            <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
            />
      </div>
    </div>
</template>
  
<script>
import PMAssessmentRecordForm from "../../../components/performance/assessmentrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": PMAssessmentRecordForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
        pageTitle: this.$t('pmassementrecord.createpmassementrecord'),
        formData: {
            pmassessmentrecordcode: null,
            pmassessmentrecorddesc: null,
            startdate: null,
            enddate: null,
            cutoffdate: null,
            statusid:null,
            ratingtype: null,
            ratingid: null,
            ratingcode: null,
            remark: null,
            pmassecalmethodid:null,
            stamp: 0,
            userid: this.$store.getters.userId,
            pmassessmentrecordreview:null,
            statusdesc:null,
            ratingtypename:null,
            calculationmethodname : null
        },

        errMsg: "",
        isErr: false,
        editMode: false,
        };
    },

    methods: {
        errorHandler($event) {
        this.isErr = $event.isErr;
        this.errMsg = $event.errMsg;
        },

        saveHandler() {
        const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                console.error("cannot add");
            return false;
        }
        this.$store.dispatch('post', {url: "/performanceassessmentrecord/create", payload: this.formData})
        .then((res) => {
        if (res.data.error) {
                vm.isErr = !vm.isErr;
                vm.errMsg = res.data.error;
            } else {
                this.$router.push({ name: "performanceassessmentrecordlist" });
            }
            })
        .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
        });

        },
    },

    created() {
    }
};
</script>